import React, { useEffect, useState } from "react"
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  Text,
  Flex,
  Divider,
} from "@chakra-ui/react"
import { ChevronDownIcon } from "@chakra-ui/icons"

const styles = {
  menuList: {
    background: "white",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    p: 6,
    w: "100%",
    fontFamily: "Inter var, sans-serif",
    position: "relative",
    zIndex: "1",
  },
  menuItem: {
    color: "#333333",
    fontSize: "14px",
    py: 2,
    px: 0,
    w: { base: "100%", md: "200px", lg: "200px" },
    _hover: {
      color: "#129459",
      fontWeight: "700",
      bg: "white",
    },
    whiteSpace: "normal",
    fontFamily: "Inter var, sans-serif",
  },
  activeItem: {
    color: "#129459",
    fontWeight: "700",
    py: 2,
    px: 0,
    bg: "white !important",
    fontSize: "14px",
  },
  button: {
    py: "8px",
    bg: "white",
    borderRadius: "4px",
    color: "black",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "175%",
    outline: "none",
    _focus: { bg: "white" },
    _hover: { bg: "white" },
    _active: { bg: "white" },
    _expanded: { bg: "white" },
    w: { base: "100%", md: "auto", lg: "auto" },
  },
  surgical: {
    borderRight: "1px solid #D9DCE6",
    width: { base: "200px", md: "200px", lg: "200px" },
    paddingRight: "24px",
  },
}

const Dropdown = ({ options, onSelect, isSpecialist = false, location }) => {
  const searchParams = new URLSearchParams(location.search)
  const [selected, setSelected] = useState(null)
  const selectedYear = searchParams.get("year") || "2025"

  const data = !isSpecialist ? options : options[selectedYear]
  const pathname = location?.pathname

  useEffect(() => {
    if (!selected && data) {
      let match = null

      if (!isSpecialist) {
        match = data.find(item => item.path === pathname)
        if (!match && selectedYear) {
          match = data.find(item => item.label === selectedYear)
        }

        if (!match) {
          match = data.find(item => !item.path)
        }
      } else {
        if (data?.overall?.path === pathname) {
          match = data.overall
        } else {
          match =
            data?.surgical?.find(item => item.path === pathname) ||
            data?.medical?.find(item => item.path === pathname)
        }
      }

      if (match) {
        setSelected(match)
        onSelect?.(match)
      }
    }
  }, [data, pathname, selected, isSpecialist, onSelect, selectedYear])

  const handleSelect = item => {
    setSelected(item)
    onSelect?.(item)
  }

  const getItemStyles = item => {
    const isActive = selected?.label === item?.label || pathname === item?.path
    return isActive ? styles.activeItem : styles.menuItem
  }

  return (
    <Menu autoSelect={false}>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon sx={{ fontSize: "24px" }} />}
        sx={styles.button}
      >
        {selected?.label || "Select Subspeciality"}
      </MenuButton>

      <MenuList sx={styles.menuList}>
        {!isSpecialist ? (
          data?.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => handleSelect(item)}
              sx={getItemStyles(item)}
            >
              {item.label}
            </MenuItem>
          ))
        ) : (
          <>
            <Box mb={4}>
              <Text fontWeight="bold" mb={2} color="#595C5F" fontSize="12px">
                OVERALL
              </Text>
              <MenuItem
                onClick={() => handleSelect(data?.overall)}
                sx={getItemStyles(data?.overall)}
              >
                {data?.overall?.label}
              </MenuItem>
            </Box>

            <Divider
              orientation="vertical"
              borderColor="gray.300"
              borderWidth="1px"
            />

            <Flex gap={6} mt={4}>
              <Box sx={styles.surgical}>
                <Text fontWeight="bold" mb={2} color="#595C5F" fontSize="12px">
                  SURGICAL
                </Text>
                {data?.surgical?.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleSelect(item)}
                    sx={getItemStyles(item)}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Box>

              <Box>
                <Text fontWeight="bold" mb={2} color="#595C5F" fontSize="12px">
                  MEDICAL
                </Text>
                {data?.medical?.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleSelect(item)}
                    sx={getItemStyles(item)}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Box>
            </Flex>
          </>
        )}
      </MenuList>
    </Menu>
  )
}

export default Dropdown
